import GoInactive from './go-inactive';

export default GoInactive;
